import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button,
  Modal,
} from '../../../components/index';
import {
  validateObject, doGet,
} from '../../../utils/requests';
import { sexo, estadoCivil, vinculo, capacidade, motivoInclusao, parecerMedico } from '../../../utils/listsSelect';
import Masks from '../../../utils/masks';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';

const camposCnis = [
  'nome',
  'dataNascimento',
  'sexo',
  'nomeMae',
];

class Dependente extends Component {
  static getDerivedStateFromProps(props, state) {
    const { validadeCampos } = { ...state };
    if (props.dependente && !state.didProps) {
      if (props.acao === 'cumprir-exigencia' && props.exigencias) {
        if (props.exigencias.some(exigencia => exigencia.tipo !== 11)) {
          props.exigencias.forEach((item) => {
            validadeCampos[item.atributo] = false;
          });
          return ({
            dependente: { ...props.dependente },
            touched: true,
            validadeCampos,
            didProps: true,
            exigenciasDependente: props.exigencias,
          });
        }
      }
      if (props.errosDependente) {
        props.errosDependente.forEach((item) => {
          if (item.atributo) {
            validadeCampos[item.atributo] = false;
          }
        });
        return ({
          dependente: { ...props.dependente },
          validadeCampos,
          errosDependente: props.errosDependente,
          touched: true,
          didProps: true,
        });
      }
      return ({
        dependente: { ...props.dependente },
        dependenteVindoDoProps: { ...props.dependente },
        touched: true,
        didProps: true,
      });
    }
    return null;
  }

  constructor(props) {
    super();
    const state = this.getInitialState();
    if (props.dependente) {
      const { validadeCampos } = { ...state };
      Object.keys(validadeCampos).forEach((key) => {
        validadeCampos[key] = true;
      });
      state.validadeCampos = validadeCampos;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      dependente: {
        cpfDependente: null,
        nome: null,
        nomeMae: null,
        dataNascimento: null,
        sexo: null,
        estadoCivil: null,
        vinculo: null,
        capacidade: null,
        motivoInclusao: null,
        invalidezDeAcordoMedico: null,
      },
      touched: false,
      validadeCampos: {
        cpfDependente: false,
        nome: false,
        nomeMae: false,
        dataNascimento: false,
        sexo: false,
        estadoCivil: false,
        vinculo: false,
        capacidade: false,
      },
      didUpdate: false,
      didProps: false,
      exigenciasDependente: null,
      errosDependente: null,
      estadoFormulario: 'inicial',
      dependenteVindoDoProps: null,
    };
    return initialState;
  }

  verificaCumprimentoExigencia = () => {
    if (this.state.exigenciasDependente) {
      let exigenciaCumprida = false;
      let houveAlteracao = false;
      this.state.exigenciasDependente.forEach((item) => {
        if (item.atributo) {
          if (item.atributo in this.state.validadeCampos
          && this.state.validadeCampos[item.atributo]) {
            exigenciaCumprida = true;
          }
        }
      });
      if (exigenciaCumprida) {
        houveAlteracao = exigenciaCumprida;
      } else {
        houveAlteracao = this.verificaAlteracaoCamposDependente();
        const { requestPesquisa } = { ...this.state };
        const alterouPeloBotaoPesquisar = requestPesquisa;
        if (alterouPeloBotaoPesquisar) {
          return true;
        }
        if (houveAlteracao) {
          this.state.requerimento.exigencias.forEach((exigencia) => {
            const paramAtributo = exigencia.atributo;
            if (paramAtributo && exigencia.atendida === 0) {
              if (paramAtributo in this.state.validadeCampos) {
                this.state.validadeCampos[paramAtributo] =
                !this.state.validadeCampos[paramAtributo];
              }
            }
          });

          houveAlteracao = validateObject(this.state.validadeCampos);

          this.state.requerimento.exigencias.forEach((exigencia) => {
            const paramAtributo = exigencia.atributo;
            if (paramAtributo && exigencia.atendida === 0) {
              if (paramAtributo in this.state.validadeCampos) {
                this.state.validadeCampos[paramAtributo] =
                !this.state.validadeCampos[paramAtributo];
              }
            }
          });
        }
      }
      return houveAlteracao;
    }
    return validateObject(this.state.validadeCampos);
  }

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.props };
    const { estadoFormulario } = { ...this.state };

    switch (acao) {
      case 'novo': {
        if (estadoFormulario === 'inicial') {
          return validateObject(this.state.validadeCampos);
        }
        return estadoFormulario === 'alterado';
      }
      case 'cumprir-exigencia': return this.verificaCumprimentoExigencia();
      case 'realizar-analise': return false;
      case 'indeferidos': return validateObject(this.state.validadeCampos);
      case 'emitir-parecer-medico': return validateObject(this.state.validadeCampos);
      default: return false;
    }
  }

  resetState = () => {
    this.setState(this.getInitialState());
    this.props.onHide();
    this.props.resetDependente();
  }

  handleButton = () => {
    const touched = true;
    this.setState({ ...this.state, touched }, this.handleEnviar);
  }

  handleEnviar = () => {
    this.props.addDependente(
      this.state.dependente,
      this.props.dependente,
    );
    if (this.state.exigenciasDependente) {
      this.props.validacaoExigenciaDependente(this.state.exigenciasDependente);
    }
    if (this.state.errosDependente) {
      this.props.validacaoErrosDependentes(this.state.errosDependente);
    }
    this.resetState();
  }

  handleChange = (changeObj, name) => {
    const { acao } = { ...this.props };
    let { estadoFormulario } = { ...this.state };

    if (acao === 'cumprir-exigencia') {
      estadoFormulario = 'alterado';
    } else if (acao === 'novo' && this.state.errosDependente && this.state.errosDependente.length >= 1) {
      estadoFormulario = 'alterado';
    }

    this.setState({
      dependente: {
        ...this.state.dependente,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
      estadoFormulario,
    });
  }

  trataSucessoResponsePesquisa = (response) => {
    const { validadeCampos } = { ...this.state };
    delete response.data.nit;
    camposCnis.forEach((key) => {
      validadeCampos[key] = true;
    });
    this.setState({
      dependente: {
        ...this.state.dependente,
        ...response.data,
      },
      validadeCampos,
      touched: true,
    });
  }

  trataErrosResponse = () => {
    const { validadeCampos } = { ...this.state };
    const { dependente } = { ...this.state };

    camposCnis.forEach((key) => {
      validadeCampos[key] = false;
      dependente[key] = '';
    });

    this.setState({
      dependente: { ...this.state.dependente, dependente },
      validadeCampos,
    });
  }

  handleSearch = () => {
    if (this.state.validadeCampos.cpfDependente) {
      const { cpfDependente } = { ...this.state.dependente };
      this.setState(
        { requestPesquisa: true },
        doGet(
          `pessoas-fisicas/${cpfDependente}`,
          this.trataSucessoResponsePesquisa,
          this.trataErrosResponse,
        ),
      );
    }
  }

  // Para cada Input, sinalizar as acoes em que o mesmo pode ser alterado
  desabilitaInput = (listaAcoesEditaveis) => {
    if (this.props.consulta) {
      return true;
    }
    return !listaAcoesEditaveis.includes(this.props.acaoModal);
  }

  // Escolhe o titulo do modal baseado na acao
  determinaTitulo = () => {
    let titulo;
    switch (this.props.acaoModal) {
      case 'pericia-medica': titulo = 'Parecer médico para o dependente';
        break;
      case 'em-analise': titulo = 'Dependente';
        break;
      case 'edicao': titulo = 'Edição de dependente';
        break;
      default: titulo = 'Inclusão de Dependente';
    }
    return titulo;
  }

  verificaAlteracaoCamposDependente = () => {
    const { dependente } = { ...this.state };
    const { dependenteVindoDoProps } = { ...this.state };
    const depOriginal = dependenteVindoDoProps;
    const depAtual = dependente;
    let houveAlteracao = false;

    if (depOriginal !== null) {
      if (depAtual.cpfDependente !== undefined) {
        if ((depOriginal.cpfDependente === undefined &&
          depAtual.cpfDependente !== null) ||
          (depOriginal.cpfDependente !== depAtual.cpfDependente)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.nome !== undefined) {
        if (depOriginal.nome &&
          ((depOriginal.nome !== depAtual.nome)
          && depAtual.nome !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.nomeMae !== undefined) {
        if (depOriginal.nomeMae &&
          ((depOriginal.nomeMae !== depAtual.nomeMae)
          && depAtual.nome !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.dataNascimento !== undefined) {
        if (depOriginal.dataNascimento &&
          ((depOriginal.dataNascimento !== depAtual.dataNascimento)
          && depAtual.dataNascimento !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.sexo !== undefined) {
        if (depOriginal.sexo &&
          ((depOriginal.sexo !== depAtual.sexo)
          && depAtual.sexo !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.estadoCivil !== undefined) {
        if (depOriginal.estadoCivil &&
          ((depOriginal.estadoCivil !== depAtual.estadoCivil)
          && depAtual.estadoCivil !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.vinculo !== undefined) {
        if (depOriginal.vinculo &&
          ((depOriginal.vinculo !== depAtual.vinculo)
          && depAtual.vinculo !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.capacidade !== undefined) {
        if (depOriginal.capacidade &&
          ((depOriginal.capacidade !== depAtual.capacidade)
          && depAtual.capacidade !== null)) {
          houveAlteracao = true;
        }
      }
      if (depAtual.motivoInclusao !== undefined) {
        if ((depOriginal.motivoInclusao === undefined &&
          depAtual.motivoInclusao !== null) ||
          (depOriginal.motivoInclusao !== depAtual.motivoInclusao)) {
          houveAlteracao = true;
        }
      }
    }
    return houveAlteracao;
  }

  render() {
    let inputInvalidezMedico;
    let modalFooter;
    let pesquisar;
    // let consulta;
    if (this.props.acaoModal === 'pericia-medica') {
      inputInvalidezMedico = (
        <ProtectedItem allowedPermissions={['fornecer-parecer-medico-rpps']}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                label="É dependente inválido na data da concessão do benefício?"
                value={this.state.dependente.invalidezDeAcordoMedico}
                itemList={parecerMedico}
                onChange={e => this.handleChange(e, 'invalidezDeAcordoMedico')}
                placeholder="Selecione a opção"
              />
            </Grid>
          </div>
        </ProtectedItem>
      );
    }
    if ((this.props.acaoModal === 'criacao' || this.props.acaoModal === 'edicao'
    || this.props.acaoModal === 'indeferidos') && !this.props.consulta) {
      pesquisar = (
        <Button
          title="Pesquisar"
          onClick={() => this.handleSearch()}
          hint="Pesquisar dados pessoais"
        />
      );
    }
    const modalContent = (
      <React.Fragment>
        <div className="row" style={{ height: '370px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                error={!this.state.validadeCampos.cpfDependente}
                cpf
                integer
                label="CPF"
                onChange={e => this.handleChange(e, 'cpfDependente')}
                required
                mask={Masks.cpf}
                showMask
                touched={this.state.touched}
                value={this.state.dependente.cpfDependente}
              />
            </Grid>
            {pesquisar}
            <Grid cols="12 12 12 12">
              <Input
                disabled={this.desabilitaInput(['criacao'])}
                label="Nome"
                maxLength="60"
                error={!this.state.validadeCampos.nome}
                value={this.state.dependente.nome}
                onChange={e => this.handleChange(e, 'nome')}
                touched={this.state.touched}
                required
              />
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Nome da Mãe"
                maxLength="60"
                error={!this.state.validadeCampos.nomeMae}
                value={this.state.dependente.nomeMae}
                onChange={e => this.handleChange(e, 'nomeMae')}
                touched={this.state.touched}
                required
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao'])}
                label="Data de Nascimento"
                mask={Masks.date}
                error={!this.state.validadeCampos.dataNascimento}
                value={this.state.dependente.dataNascimento}
                onChange={e => this.handleChange(e, 'dataNascimento')}
                touched={this.state.touched}
                required
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Sexo"
                error={!this.state.validadeCampos.sexo}
                value={this.state.dependente.sexo}
                number
                itemList={sexo}
                onChange={e => this.handleChange(e, 'sexo')}
                touched={this.state.touched}
                placeholder="Selecione o sexo"
                required
                custom
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Estado Civil"
                error={!this.state.validadeCampos.estadoCivil}
                value={this.state.dependente.estadoCivil}
                number
                itemList={estadoCivil}
                onChange={e => this.handleChange(e, 'estadoCivil')}
                touched={this.state.touched}
                placeholder="Selecione o estado civil"
                required
                custom
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Vínculo"
                error={!this.state.validadeCampos.vinculo}
                value={this.state.dependente.vinculo}
                number
                itemList={vinculo}
                onChange={e => this.handleChange(e, 'vinculo')}
                touched={this.state.touched}
                placeholder="Selecione o vínculo"
                required
                custom
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Capacidade"
                error={!this.state.validadeCampos.capacidade}
                value={this.state.dependente.capacidade}
                number
                itemList={capacidade}
                onChange={e => this.handleChange(e, 'capacidade')}
                touched={this.state.touched}
                placeholder="Selecione a capacidade"
                required
                custom
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.desabilitaInput(['criacao', 'edicao', 'indeferidos'])}
                label="Motivo de Inclusão"
                value={this.state.dependente.motivoInclusao}
                number
                itemList={motivoInclusao}
                onChange={e => this.handleChange(e, 'motivoInclusao')}
                placeholder="Selecione o motivo de inclusão"
                custom
              />
            </Grid>
          </div>
          {inputInvalidezMedico}
        </div>
      </React.Fragment>
    );
    // Existe footer sempre que a acao do modal nao for analisar
    if (!['em-analise'].includes(this.props.acaoModal) && !this.props.consulta) {
      modalFooter = (
        <React.Fragment>
          <div className="right">
            <Button
              title="Cancelar"
              onClick={this.resetState}
              hint="Cancelar"
            />
            <Button
              className="dtp-primary"
              disabled={!this.formularioProntoParaEnvio()}
              title={this.props.dependente ? 'Salvar' : 'Adicionar'}
              onClick={(this.handleButton)}
              hint={this.props.dependente ? 'Salvar dependente' : 'Adicionar dependente'}
            />
          </div>
        </React.Fragment>
      );
    }
    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.resetState}
        showTitle
        size="lg"
        title={this.determinaTitulo()}
      />
    );
  }
}

Dependente.propTypes = {
  acaoModal: PropTypes.oneOf(['criacao', 'edicao', 'em-analise', 'pericia-medica']),
  onHide: PropTypes.func,
  consulta: PropTypes.bool,
}.isRequired;

export default Dependente;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Pensao/Dependente.jsx